import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=2bb4c432&scoped=true&"
import script from "./ServiceList.vue?vue&type=script&lang=js&"
export * from "./ServiceList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=2bb4c432&prod&scoped=true&lang=css&"
import style1 from "./ServiceList.vue?vue&type=style&index=1&id=2bb4c432&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4c432",
  null
  
)

export default component.exports